import MixpanelService from './mixpanel-service';
import { extractPathIdentifier } from '../helpers/api-helpers';
import { COMMON_PAGE_PATHS } from '../../constans/url-constants';

let mixpanelService: MixpanelService | null = null;

const getMixpanelService = (): MixpanelService => {
  if (mixpanelService == null) {
    mixpanelService = new MixpanelService(extractPathIdentifier(COMMON_PAGE_PATHS.PRESENTATION));
  }

  return mixpanelService;
};

export { getMixpanelService };
